import React from 'react'
import PropTypes from 'prop-types'

import Delete from '#components/svg/icons/Delete'
import WorkingHour from '#components/svg/icons/WorkingHour'
import Chain from '#components/svg/icons/Chain'

class IconText extends React.Component {
  render() {
    let modifier
    if (this.props.modifier) {
      modifier = ` icontext--${this.props.modifier}`
    }

    let Svg
    switch (this.props.icon) {
      case 'delete':
        Svg = <Delete />
        modifier += ' icontext--hover-warning'
        break
      case 'clock':
        Svg = <WorkingHour />
        break
      case 'chain':
        Svg = <Chain />
        break
      default:
        break
    }

    return (
      <div
        role="button"
        id={this.props.id}
        onClick={this.props.event}
        onKeyPress={this.props.event}
        onMouseDown={this.props.onMouseDown}
        disabled={this.props.disabled}
        className={`icontext${modifier}`}>
        {Svg}
        <span>{this.props.text}</span>
      </div>
    )
  }
}

IconText.propTypes = {
  event: PropTypes.func,
  id: PropTypes.string,
  text: PropTypes.string,
  modifier: PropTypes.string,
  icon: PropTypes.string,
  disabled: PropTypes.bool,
  onMouseDown: PropTypes.func,
}

export default IconText
